import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { AddEventParticipantsDto, PublicEvent } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const addParticipantsToEvent = async ({
  orgId,
  eventId,
  payload,
}: {
  orgId: string;
  eventId: string;
  payload: AddEventParticipantsDto;
}) => {
  const response = await axiosClient.post(
    `${orgId}/events/${eventId}/participants`,
    payload,
  );
  return response.data;
};

export function useAddParticipantToEvent(
  queryOptions?: UseMutationOptions<
    PublicEvent,
    HttpError,
    { orgId: string; eventId: string; payload: AddEventParticipantsDto }
  >,
) {
  return useMutation({
    mutationFn: addParticipantsToEvent,
    ...queryOptions,
  });
}
